var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalInfoBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 930,
    height: 650.239,
    viewBox: "0 0 930 650.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personal_info_bg",
    transform: "translate(-1135 -326.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personal_info",
    transform: "translate(1135 326.869)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1175",
    "data-name": "Rectangle 1175",
    width: 930,
    height: 650,
    transform: "translate(0 -0.103)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47776",
    "data-name": "Path 47776",
    d: "M645.342,579.212c-.547.977-1.08,1.968-1.642,2.959s-1.228,2.131-1.864,3.181-1.169,1.894-1.761,2.826-1.48,2.279-2.234,3.4c-.548.814-1.095,1.613-1.672,2.427-.74,1.05-1.48,2.086-2.249,3.107s-1.272,1.687-1.924,2.515q-2.086,2.708-4.335,5.327c-.74.873-1.48,1.716-2.264,2.575h0c-.74.814-1.48,1.628-2.249,2.441l-.1.133c-.74.784-1.48,1.48-2.234,2.323s-1.82,1.835-2.752,2.723c-1.287,1.273-2.619,2.5-3.951,3.714l-.1.089c-.444.414-.873.784-1.3,1.169-1.48,1.346-3.063,2.649-4.631,3.936-.829.7-1.672,1.346-2.5,2.027l-3.226,2.471-1.687,1.243c-.3.192-.577.4-.858.607-1.332.962-2.693,1.909-4.069,2.841l-2.959,1.924-1.213.784c-1.125.725-2.293,1.48-3.448,2.145s-2.308,1.391-3.492,2.057c-.459.266-.917.533-1.376.769-.917.548-1.85,1.051-2.782,1.554-3.107,1.7-6.289,3.314-9.514,4.853-1.095.533-2.19,1.051-3.3,1.48q-2.441,1.125-4.927,2.175c-1.361.592-2.737,1.154-4.128,1.7l-.858.34c-1.332.547-2.663,1.051-4.01,1.568h0c-1.065.385-2.131.784-3.211,1.154s-1.968.71-2.959,1.051l-2.959.991-.4.133c-1.48.473-2.885.932-4.321,1.376l-.4.118-4.439,1.317-.814.237-4.261,1.169c-1.48.414-3.063.8-4.6,1.184l-.311.074h-.133c-1.554.4-3.122.755-4.676,1.125h-.148l-4.543,1.006-.962.207c-1.48.311-3.033.622-4.557.9s-3.4.651-5.12.947c-1.938.34-3.892.651-5.919.962q-2.22.355-4.439.666h-.118c-3.329.474-6.658.9-10.032,1.287l-1.006.1-4.439.459h-.621l-5.06.444h0c-1.776.148-3.551.281-5.342.4h-.148c-1.672.118-3.329.222-5,.3-3.921.237-7.887.385-11.837.473-1.642,0-3.3.089-4.957.089H432.108l-4.439-.118c-1.554,0-3.122-.089-4.691-.163-2.56-.089-5.149-.207-7.739-.355L412.976,672l-3.359-.207-2.471-.177h-.37l-2.515-.192h0c-1.051-.074-2.116-.163-3.166-.266-6.2-.518-12.429-1.154-18.644-1.924-2.16-.252-4.335-.547-6.51-.844-1.864-.252-3.729-.5-5.608-.8s-3.536-.5-5.312-.784c-2-.311-4-.636-5.919-.977l-4.069-.7-3.684-.651-2.841-.533c-1.48-.266-2.856-.533-4.291-.829l-1.169-.237-5.031-1.006-1.687-.37c-1.2-.237-2.382-.5-3.566-.769l-3.27-.71-8.538-1.983c-4.543-1.1-9.07-2.264-13.6-3.477-2.545-.666-5.09-1.376-7.62-2.086-1.968-.562-3.906-1.11-5.845-1.687l-5.4-1.613-.8-.237-5.046-1.45-.651-.192-4.927-1.6-1.2-.4c-1.48-.459-2.826-.932-4.232-1.48-3.788-1.287-7.531-2.6-11.275-3.966l-5.815-2.16c-1.716-.651-3.433-1.3-5.149-1.983-10.432-4.039-20.626-8.4-30.555-13.021l-2.959-1.346q-12.3-5.83-23.985-12.192l-1.879-1.036c-.814-.444-1.657-.9-2.471-1.376q-16.276-9.1-31.073-19.236l-4.01-2.8c-1.48-1.036-2.959-2.072-4.335-3.122s-2.856-2.1-4.261-3.167q-6.3-4.764-12.222-9.721l-3.906-3.329c-2.116-1.85-4.187-3.714-6.215-5.564-1.036-.977-2.086-1.938-3.092-2.959q-3.714-3.507-7.191-7.132c-.5-.518-1.006-1.021-1.48-1.554q-2.5-2.649-4.9-5.312l-.178-.192c-.991-1.139-1.983-2.264-2.959-3.4-.518-.592-1.036-1.2-1.48-1.805l-1.48-1.805-1.273-1.6c-1.642-2.042-3.211-4.084-4.72-6.155-.355-.488-.71-.962-1.051-1.48-.888-1.228-1.761-2.471-2.619-3.714C4.531,398.812,42.055,212.671,119.441,116.02c43.369-54.067,83.32-55.162,161.12-61.865C826.289,6.806,571.078,224.434,595.24,325.614,617.613,419.38,689.983,496.914,645.342,579.212Z",
    transform: "translate(159.039 -22.875)",
    fill: "#0074d7",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47777",
    "data-name": "Path 47777",
    d: "M645.342,579.212c-.547.977-1.08,1.968-1.642,2.959s-1.228,2.131-1.864,3.181-1.169,1.894-1.761,2.826-1.48,2.279-2.234,3.4c-.548.814-1.095,1.613-1.672,2.427-.74,1.05-1.48,2.086-2.249,3.107s-1.272,1.687-1.924,2.515q-2.086,2.708-4.335,5.327c-.74.873-1.48,1.716-2.264,2.575h0c-.74.814-1.48,1.628-2.249,2.441l-.1.133c-.74.784-1.48,1.48-2.234,2.323s-1.82,1.835-2.752,2.723c-1.287,1.273-2.619,2.5-3.951,3.714l-.1.089c-.444.414-.873.784-1.3,1.169-1.48,1.346-3.063,2.649-4.631,3.936-.829.7-1.672,1.346-2.5,2.027l-3.226,2.471-1.687,1.243c-.3.192-.577.4-.858.607-1.332.962-2.693,1.909-4.069,2.841l-2.959,1.924-1.213.784c-1.125.725-2.293,1.48-3.448,2.145s-2.308,1.391-3.492,2.057c-.459.266-.917.533-1.376.769-.917.548-1.85,1.051-2.782,1.554-3.107,1.7-6.289,3.314-9.514,4.853-1.095.533-2.19,1.051-3.3,1.48q-2.441,1.125-4.927,2.175c-1.361.592-2.737,1.154-4.128,1.7l-.858.34c-1.332.547-2.663,1.051-4.01,1.568h0c-1.065.385-2.131.784-3.211,1.154s-1.968.71-2.959,1.051l-2.959.991-.4.133c-1.48.473-2.885.932-4.321,1.376l-.4.118-4.439,1.317-.814.237-4.261,1.169c-1.48.414-3.063.8-4.6,1.184l-.311.074h-.133c-1.554.4-3.122.755-4.676,1.125h-.148l-4.543,1.006-.962.207c-1.48.311-3.033.622-4.557.9s-3.4.651-5.12.947c-1.938.34-3.892.651-5.919.962q-2.22.355-4.439.666h-.118c-3.329.474-6.658.9-10.032,1.287l-1.006.1-4.439.459h-.621l-5.06.444h0c-1.776.148-3.551.281-5.342.4h-.148c-1.672.118-3.329.222-5,.3-3.921.237-7.887.385-11.837.473-1.642,0-3.3.089-4.957.089H432.108l-4.439-.118c-1.554,0-3.122-.089-4.691-.163-2.56-.089-5.149-.207-7.739-.355L412.976,672l-3.359-.207-2.471-.177h-.37l-2.515-.192h0c-1.051-.074-2.116-.163-3.166-.266-6.2-.518-12.429-1.154-18.644-1.924-2.16-.252-4.335-.547-6.51-.844-1.864-.252-3.729-.5-5.608-.8s-3.536-.5-5.312-.784c-2-.311-4-.636-5.919-.977l-4.069-.7-3.684-.651-2.841-.533c-1.48-.266-2.856-.533-4.291-.829l-1.169-.237-5.031-1.006-1.687-.37c-1.2-.237-2.382-.5-3.566-.769l-3.27-.71-8.538-1.983c-4.543-1.1-9.07-2.264-13.6-3.477-2.545-.666-5.09-1.376-7.62-2.086-1.968-.562-3.906-1.11-5.845-1.687l-5.4-1.613-.8-.237-5.046-1.45-.651-.192-4.927-1.6-1.2-.4c-1.48-.459-2.826-.932-4.232-1.48-3.788-1.287-7.531-2.6-11.275-3.966l-5.815-2.16c-1.716-.651-3.433-1.3-5.149-1.983-10.432-4.039-20.626-8.4-30.555-13.021l-2.959-1.346q-12.3-5.83-23.985-12.192l-1.879-1.036c-.814-.444-1.657-.9-2.471-1.376q-16.276-9.1-31.073-19.236l-4.01-2.8c-1.48-1.036-2.959-2.072-4.335-3.122s-2.856-2.1-4.261-3.167q-6.3-4.764-12.222-9.721l-3.906-3.329c-2.116-1.85-4.187-3.714-6.215-5.564-1.036-.977-2.086-1.938-3.092-2.959q-3.714-3.507-7.191-7.132c-.5-.518-1.006-1.021-1.48-1.554q-2.5-2.649-4.9-5.312l-.178-.192c-.991-1.139-1.983-2.264-2.959-3.4-.518-.592-1.036-1.2-1.48-1.805l-1.48-1.805-1.273-1.6c-1.642-2.042-3.211-4.084-4.72-6.155-.355-.488-.71-.962-1.051-1.48-.888-1.228-1.761-2.471-2.619-3.714C4.531,398.812,42.055,212.671,119.441,116.02c43.369-54.067,83.32-55.162,161.12-61.865C826.289,6.806,571.078,224.434,595.24,325.614,617.613,419.38,689.983,496.914,645.342,579.212Z",
    transform: "translate(219.039 -22.875)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Information_tab-bro",
    "data-name": "Information tab-bro",
    transform: "translate(9.74 0.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M55.5,323h81a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h2.25",
    transform: "translate(-10.501 110.254)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M118.5,342.85h18a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h65.247",
    transform: "translate(-10.501 120.178)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M136.5,380.709H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h91.5a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9Z",
    transform: "translate(-10.501 130.106)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M90.5,303h45.748V426.744H75.5",
    transform: "translate(9.246 100.256)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M49,426.744H29.5V303H103",
    transform: "translate(-13.751 100.256)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 31.498,
    transform: "translate(42.748 527)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 115.494,
    transform: "translate(22.499 421.255)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M131.5,54.15h81a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H121a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h2.25",
    transform: "translate(27.493 -24.151)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M194.5,74h18a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H121a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h65.247",
    transform: "translate(27.493 -14.228)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 109.495,
    height: 17.999,
    rx: 6,
    transform: "translate(139.493 89.546)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M166.5,34.15h45.748V152.088c.058,4.648.572,5.806-3.907,5.806H151.5",
    transform: "translate(47.24 -34.15)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M125,157.894H105.5V34.15H179",
    transform: "translate(24.244 -34.15)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 31.498,
    transform: "translate(156.742 123.744)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x2: 115.494,
    transform: "translate(136.493 17.999)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M393.018,80.319H345.725A3.615,3.615,0,0,1,342.11,76.7V62.965a3.615,3.615,0,0,1,3.615-3.615H409.1a3.615,3.615,0,0,1,3.615,3.615V68.35",
    transform: "translate(142.532 -21.552)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M375.75,99.593V70.21a4.725,4.725,0,0,1,4.71-4.71h62.757a4.725,4.725,0,0,1,4.71,4.71V105.4",
    transform: "translate(159.349 -18.477)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M447.927,120.664v36.658a4.725,4.725,0,0,1-4.71,4.71H380.46a4.725,4.725,0,0,1-4.71-4.71V92.93",
    transform: "translate(159.349 -4.764)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 63.222,
    transform: "translate(539.554 64.197)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x2: 33.013,
    transform: "translate(569.763 83.261)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 25.049,
    transform: "translate(539.554 83.261)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 63.222,
    transform: "translate(539.554 102.325)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 11.324,
    transform: "translate(591.451 121.389)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 46.198,
    transform: "translate(539.554 121.389)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 63.222,
    transform: "translate(539.554 140.468)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 34.453,
    transform: "translate(497.406 47.803)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M237.492,365.819H172.3a5,5,0,0,1-4.995-4.98V341.895A5,5,0,0,1,172.3,336.9h87.341a5,5,0,0,1,4.995,4.995v7.425",
    transform: "translate(55.144 117.203)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M213.69,392.393v-40.5a6.5,6.5,0,0,1,6.495-6.495h86.5a6.5,6.5,0,0,1,6.495,6.495v48.523",
    transform: "translate(78.331 121.452)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M313.16,421.433v50.533a6.5,6.5,0,0,1-6.495,6.495h-86.5a6.5,6.5,0,0,1-6.495-6.495V383.2",
    transform: "translate(78.321 140.35)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 87.161,
    transform: "translate(298.156 490.506)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 45.523,
    transform: "translate(339.794 516.785)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    x2: 34.543,
    transform: "translate(298.156 516.785)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 87.161,
    transform: "translate(298.156 543.079)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 15.614,
    transform: "translate(369.702 569.358)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 63.687,
    transform: "translate(298.156 569.358)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 87.161,
    transform: "translate(298.156 595.636)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 47.488,
    transform: "translate(240.063 467.917)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M296.168,424.183a14.385,14.385,0,0,1-10.02-4.05l-9.285-9.21a3.36,3.36,0,0,1,4.665-4.83l1.83,1.71-9.345-19.214a4.05,4.05,0,0,1-.12-3.1,3.975,3.975,0,0,1,7.3-.3l3.48,6.855a4.11,4.11,0,0,1,2.49-1.5,5.4,5.4,0,0,1,3.69,1.065,4.02,4.02,0,0,1,2.61-1.5,4.844,4.844,0,0,1,3.12.75,2.625,2.625,0,0,1,2.73-1.65,3.765,3.765,0,0,1,3,1.98l6.6,12.134a14.4,14.4,0,0,1-12.824,20.924Zm-16.934-17.5h-.24a1.86,1.86,0,0,0-1.08,3.165l9.285,9.195a12.884,12.884,0,0,0,20.459-15.1l-6.57-12.1a2.265,2.265,0,0,0-1.8-1.2c-.615,0-1.275.105-1.5,1.5l-.225,1.365-1.02-.93a4.125,4.125,0,0,0-2.85-1.035,3,3,0,0,0-2.025,1.5l-.48.765-.675-.615a4.5,4.5,0,0,0-3.1-1.2,3.24,3.24,0,0,0-2.175,1.8l-.72,1.245-4.68-9.24a2.486,2.486,0,0,0-4.5,2.115l12.674,26.324-7.5-7.08a1.815,1.815,0,0,0-1.275-.465Z",
    transform: "translate(108.302 140.21)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M284.639,399.068a.765.765,0,0,1-.69-.465l-3.45-8.115a.765.765,0,0,1,.4-.99.75.75,0,0,1,.975.405l3.45,8.115a.75.75,0,0,1-.39.99.675.675,0,0,1-.3.06Z",
    transform: "translate(111.702 143.471)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M288.5,397.542a.75.75,0,0,1-.69-.45l-3-7.125a.75.75,0,0,1,.39-.99.78.78,0,0,1,.99.4l3,7.125a.735.735,0,0,1-.4.975.614.614,0,0,1-.285.06Z",
    transform: "translate(113.855 143.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M292.394,396.2a.72.72,0,0,1-.675-.435l-2.895-6.225a.735.735,0,0,1,.36-.99.75.75,0,0,1,1.005.36l2.895,6.225a.735.735,0,0,1-.69,1.065Z",
    transform: "translate(115.856 142.99)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1170",
    "data-name": "Rectangle 1170",
    width: 20.999,
    height: 20.999,
    transform: "translate(367.632 30.303) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1171",
    "data-name": "Rectangle 1171",
    width: 20.999,
    height: 20.999,
    transform: "translate(625.768 193.783) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1172",
    "data-name": "Rectangle 1172",
    width: 20.999,
    height: 20.999,
    transform: "translate(171.293 553.781) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1173",
    "data-name": "Rectangle 1173",
    width: 11.459,
    height: 11.459,
    transform: "translate(346.781 50.767) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1174",
    "data-name": "Rectangle 1174",
    width: 11.459,
    height: 11.459,
    transform: "translate(339.288 445.256) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(265.487 505.251)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(457.478 439.254)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(623.97 76.271)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(0 94.795)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Switches--inject-5",
    transform: "translate(440.342 98.158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12852",
    "data-name": "Rectangle 12852",
    width: 231.878,
    height: 361.925,
    rx: 24,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47718",
    "data-name": "Path 47718",
    d: "M330.376,253.806H232.955a25.45,25.45,0,0,1-25.435-25.45h0c0-14.042,11.393-25.435,31.073-25.435h97.421c8.449,0,19.842,11.393,19.842,25.435h0a25.45,25.45,0,0,1-25.48,25.45Z",
    transform: "translate(-163.411 51.774)",
    fill: "#0074d7",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 20.02,
    cy: 20.02,
    r: 20.02,
    transform: "translate(142.272 297.05) rotate(-80.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47721",
    "data-name": "Path 47721",
    d: "M330.376,120.176H232.955A25.435,25.435,0,0,1,207.52,94.74h0c0-14.057,11.393-25.45,31.073-25.45h97.421c8.449,0,19.842,11.393,19.842,25.45h0A25.45,25.45,0,0,1,330.376,120.176Z",
    transform: "translate(-163.411 -12.323)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47722",
    "data-name": "Path 47722",
    d: "M281.666,120.176h-48.71A25.435,25.435,0,0,1,207.52,94.74h0c0-14.057,11.393-25.45,31.073-25.45h43.1Z",
    transform: "translate(-163.411 -12.323)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 25.435,
    cy: 25.435,
    r: 25.435,
    transform: "translate(92.449 56.982)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47728",
    "data-name": "Path 47728",
    d: "M330.376,188.016H232.955A25.435,25.435,0,0,1,207.52,162.58h0a25.45,25.45,0,0,1,25.435-25.45h97.421a25.45,25.45,0,0,1,25.45,25.45h0A25.45,25.45,0,0,1,330.376,188.016Z",
    transform: "translate(-163.411 20.217)",
    fill: "#999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 20.02,
    cy: 20.02,
    r: 20.02,
    transform: "translate(48.548 162.467)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-5",
    transform: "translate(556.279 376.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47732",
    "data-name": "Path 47732",
    d: "M372.6,468.794H372.5c-1.076.267-2.163.523-3.249.769h-.092c-1.025.246-2.05.482-3.146.707l-.666.133-3.157.635c-1.179.225-2.357.441-3.546.646-1.343.236-2.706.461-4.1.676-1.025.164-2.05.307-3.075.461h-.082c-2.306.328-4.612.625-6.949.881l-.7.082-3.075.318h-.431l-3.505.308h0l-3.7.287h-.113c-1.148.082-2.3.143-3.454.2-2.726.154-5.463.256-8.2.328-1.138,0-2.286.051-3.444.061s-2.552,0-3.833,0h-5.74l-3.075-.072c-1.086,0-2.163-.061-3.249-.113-1.773-.062-3.567-.154-5.36-.256L295,474.759c-.779,0-1.548-.082-2.327-.133-.574,0-1.138-.092-1.712-.123h-.256c-1.384-3.382-2.675-6.324-3.761-8.4-2.706-5.176-13.232-19.238-13.232-19.238s-10.813.123-24.885-13.047-30.532-30.891-30.286-44.594c.184-9.819-1.63-16.03-2.491-21.677a30.493,30.493,0,0,1-.4-6.611c.195-2.941.953-6.15.922-9.573,0-5.811-.687-11.9,1.906-14.974,4.1-4.9,16.327-.492,18.776,9.48s3.618,30.911,7.718,30.748,4.274-15.538,9.747-31.588l2.6-17.424,1.025-33.607.072-6.7s-2.972-16.88,1.845-25.572c0,0,4.868-8.333,10.546-1.23,5.125,6.426,4.981,8.538,8.7,31.772s.359,37.122,4.253,37.512,4.971-2.921,4.95-8.691.143-16.665,8.855-16.563,14.257,3.423,13.836,11.541-.451,14.615.912,15.1c0,0-1.548-8.978.369-14.267.84-2.316,2.4-5.073,9.634-2.255s7.964,7.666,8.753,12.945,1.865,9.7,1.865,9.7,8.8-.471,12.022,5.494,6.406,22.968,7.533,29.015c2.972,15.835-1.209,33.218-3.628,41.325a13.641,13.641,0,0,0,.564,9.47C352.754,430.062,363.731,450.181,372.6,468.794Z",
    transform: "translate(-215.615 -257.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47733",
    "data-name": "Path 47733",
    d: "M277.371,431.339c-.533-5.709-10.249,2.89-33.095-17.137-25.356-22.22-18.858-60.306-23.337-58.42s-4.879,9.347-4.879,9.347c.861,5.647,2.675,11.858,2.491,21.677-.246,13.7,16.214,31.434,30.286,44.594s24.885,13.047,24.885,13.047,10.526,14.062,13.232,19.238c1.086,2.05,2.378,5.022,3.761,8.4h.256c.574,0,1.138.082,1.712.123.779,0,1.548.1,2.327.133l1.568.092c1.794.1,3.587.195,5.36.256-2.409-5.76-4.428-10.372-5.524-12.412C292.047,452.165,278.037,438.451,277.371,431.339Z",
    transform: "translate(-215.604 -255.179)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47734",
    "data-name": "Path 47734",
    d: "M295.917,338.324a6.261,6.261,0,0,0-.236,2.583,34.386,34.386,0,0,0,2.8,11.028.676.676,0,0,0,1.291-.359,111.436,111.436,0,0,1-1.5-15.691C298.274,334.983,296.224,337.514,295.917,338.324Z",
    transform: "translate(-213.621 -255.678)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47735",
    "data-name": "Path 47735",
    d: "M320.864,348.606a96.558,96.558,0,0,1-1.445-10.372c0-.164-.082-.2-.2-.154a7.39,7.39,0,0,0-2.05,2.737,6.151,6.151,0,0,0-.061,2.593,28.7,28.7,0,0,0,1.373,5.8,1.158,1.158,0,0,0,1.466.769,1.127,1.127,0,0,0,.922-1.373Z",
    transform: "translate(-213.089 -255.619)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47736",
    "data-name": "Path 47736",
    d: "M257.7,287.178l-.072,6.693-1.025,33.6L254,344.891c-4.4,12.893-5.371,25.326-7.707,29.815l-.051.512c-.1,1.025,0,2.47.963,2.644.717.133,1.363-.6,1.835-1.271,8.722-12.453,15.425-34.007,11.52-60.7-.82-5.647,0-18.2,3.9-22.261-1.64-12.422-3.864-18.9-5.576-30.625C255.035,272,257.7,287.178,257.7,287.178Z",
    transform: "translate(-214.853 -257.489)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47737",
    "data-name": "Path 47737",
    d: "M267.625,340.177a9.767,9.767,0,0,0,0,4.1,50.88,50.88,0,0,0,4.643,14.615A1.353,1.353,0,0,0,274.8,358a165.566,165.566,0,0,1-3.741-21.933C270.905,334.683,268.015,338.865,267.625,340.177Z",
    transform: "translate(-214.325 -255.675)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47738",
    "data-name": "Path 47738",
    d: "M277.584,297.551a4.387,4.387,0,0,0-3-4.028c-2.05-.769-5.35-.851-4.961.83a12.542,12.542,0,0,1,3.454,1.168c3.351,2.46,1.3,4.715,1.3,4.715C275.965,301.066,277.492,299.334,277.584,297.551Z",
    transform: "translate(-214.27 -256.742)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47739",
    "data-name": "Path 47739",
    d: "M334.9,342.413c-.051-.676-1.507,1.363-1.7,2.05a4.734,4.734,0,0,0,0,2.05,22.241,22.241,0,0,0,1.025,4.469.933.933,0,0,0,1.794-.471,74.653,74.653,0,0,1-1.117-8.1Z",
    transform: "translate(-212.688 -255.514)",
    fill: "#0074d7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47740",
    "data-name": "Path 47740",
    d: "M290.726,474.543c-1.455-3.587-2.624-6.221-3.761-8.4-2.706-5.176-13.232-19.248-13.232-19.248s-10.8.133-24.885-13.037-30.532-30.891-30.286-44.594-3.382-20.4-2.89-28.288c.184-2.941.953-6.15.912-9.573,0-5.822-.676-11.9,1.906-14.974,4.1-4.9,16.327-.492,18.776,9.48s3.628,30.911,7.728,30.747,4.274-15.538,9.747-31.588l2.6-17.424,1.025-33.6.072-6.693s-2.972-16.891,1.845-25.623c0,0,4.868-8.333,10.546-1.23,5.125,6.426,4.981,8.538,8.7,31.772s.359,37.133,4.253,37.532,4.971-2.931,4.94-8.7.154-16.665,8.876-16.552,14.236,3.423,13.836,11.53-.461,14.615.9,15.107c0,0-1.548-8.988.359-14.277.84-2.316,2.409-5.073,9.644-2.265s7.964,7.677,8.743,12.955,1.876,9.7,1.876,9.7,8.8-.471,12.022,5.494,6.406,22.979,7.543,29.026c2.952,15.825-1.22,33.207-3.649,41.314a13.7,13.7,0,0,0,.574,9.47c3.28,7.492,14.267,27.611,23.122,46.224",
    transform: "translate(-215.615 -257.623)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47741",
    "data-name": "Path 47741",
    d: "M218.57,346.132a10.137,10.137,0,0,1,3.772-2.6c4.848-2.183,6.519-2.532,5.9-7.759",
    transform: "translate(-215.541 -255.676)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47742",
    "data-name": "Path 47742",
    d: "M225.56,351.342c.7-.328,1.425-.635,2.2-.912",
    transform: "translate(-215.367 -255.311)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47743",
    "data-name": "Path 47743",
    d: "M217.8,357.378a22.774,22.774,0,0,1,6.354-5.248",
    transform: "translate(-215.561 -255.268)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47744",
    "data-name": "Path 47744",
    d: "M260.19,264a2.409,2.409,0,0,0,2.491,2.419c2.5.062,9.071,1.435,8.292-1.537",
    transform: "translate(-214.504 -257.464)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47745",
    "data-name": "Path 47745",
    d: "M268.61,291.707a18.58,18.58,0,0,1,7.256.184",
    transform: "translate(-214.295 -256.78)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47746",
    "data-name": "Path 47746",
    d: "M264,292.915s.707-.287,1.865-.615",
    transform: "translate(-214.41 -256.759)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47747",
    "data-name": "Path 47747",
    d: "M328.89,329.39c.348,2.737,2.234,9.276,2.234,9.276",
    transform: "translate(-212.793 -255.835)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47748",
    "data-name": "Path 47748",
    d: "M280.92,373.78c5.186,13.088,9.224,25.623,15.435,39.213",
    transform: "translate(-213.988 -254.729)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47749",
    "data-name": "Path 47749",
    d: "M275.79,361.68c1.025,2.265,2.05,4.51,2.941,6.723",
    transform: "translate(-214.116 -255.03)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_505",
    "data-name": "Line 505",
    x2: 0.246,
    y2: 12.77,
    transform: "translate(123.794 111.58)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_506",
    "data-name": "Line 506",
    x2: 0.061,
    y2: 3.392,
    transform: "translate(123.682 105.512)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47750",
    "data-name": "Path 47750",
    d: "M296.517,332.22c-.113,3.188-.195,5.668-.277,8.271-.1,3.075,2.05,7.174,3.228,10.085,2.05,5.125,3.023,11.418,4.407,16.768",
    transform: "translate(-213.606 -255.764)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47751",
    "data-name": "Path 47751",
    d: "M304.51,371.36l2.89,12.145",
    transform: "translate(-213.4 -254.789)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47752",
    "data-name": "Path 47752",
    d: "M320.956,337.55l-.615,5.637a12.392,12.392,0,0,0,1.281,6.836l.861,12.524",
    transform: "translate(-213.007 -255.631)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47753",
    "data-name": "Path 47753",
    d: "M219.29,391.92a48.745,48.745,0,0,0,19.74,22.835",
    transform: "translate(-215.524 -254.277)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47754",
    "data-name": "Path 47754",
    d: "M260.94,427.89l7.646,3.352c1.117,4.223-1.22,6.744,10.516,20.365",
    transform: "translate(-214.486 -253.38)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfoBg2);
export default __webpack_public_path__ + "static/media/personal_info_bg2.4678f727a3fa7cc1e618e1b6bc99181f.svg";
export { ForwardRef as ReactComponent };